module.exports = __webpack_public_path__ + "img/e3.6783d0a9.png";